interface Props {
  lang: "en" | "ru";
}

export default function K4MHero({ lang }: Props) {
  const isRu = lang === "ru";

  return (
    <section
      className="relative min-h-[70vh] flex items-end overflow-hidden"
      style={{ background: "#0a0f1e" }}
    >
      {/* Background — high-res engine block photo */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/30e1bca6b7c4de0de3e4d84153f40c05.jpg"
          alt="Precision engine block manufacturing OEM quality cast iron cylinder block China B2B wholesale"
          title="Precision Engine Block Manufacturing — 1:1 OEM Quality | Chirunnexa"
          className="w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(to right, rgba(8,12,24,0.97) 0%, rgba(8,12,24,0.78) 55%, rgba(8,12,24,0.35) 100%)" }}
        />
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(to top, rgba(8,12,24,0.92) 0%, transparent 50%)" }}
        />
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-24">
        {/* Eyebrow */}
        <div
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8"
          style={{ background: "rgba(245,158,11,0.12)", border: "1px solid rgba(245,158,11,0.35)" }}
        >
          <div className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#F59E0B" }} />
          <span className="text-xs tracking-widest uppercase font-medium" style={{ color: "#FCD34D", letterSpacing: "0.2em" }}>
            {isRu ? "Прямые B2B поставки из Китая" : "Direct B2B Wholesale from China"}
          </span>
        </div>

        {/* H1 — SEO Optimized */}
        <h1
          className="font-thin text-white mb-4 leading-tight"
          style={{ fontSize: "clamp(1.75rem, 4vw, 3.4rem)", letterSpacing: "0.03em" }}
        >
          {isRu ? (
            <>
              Производство блоков цилиндров:
              <br />
              <span style={{ color: "#F59E0B" }}>Качество 1:1 OEM</span>
            </>
          ) : (
            <>
              Precision Engine Block Manufacturing:
              <br />
              <span style={{ color: "#F59E0B" }}>1:1 OEM Quality</span>
            </>
          )}
        </h1>

        {/* H2 subtitle */}
        <p
          className="font-light mb-6"
          style={{ fontSize: "clamp(0.8rem, 1.4vw, 1rem)", color: "rgba(245,158,11,0.85)", letterSpacing: "0.06em" }}
        >
          {isRu
            ? "Интегрированный литейный завод и ЧПУ-обработка для глобальных B2B поставок."
            : "Integrated Foundry & CNC Machining for Global B2B Supply."}
        </p>

        <div className="mb-8" style={{ width: "60px", height: "2px", background: "#F59E0B" }} />

        <p className="text-base font-light max-w-xl mb-10" style={{ color: "rgba(255,255,255,0.7)", lineHeight: "1.85" }}>
          {isRu
            ? "Собственный литейный завод + линии ЧПУ-обработки. Реверс-инжиниринг по образцу. Серийное производство блоков цилиндров — от расплавленного чугуна до готового изделия."
            : "Proprietary foundry + CNC machining lines. Sample-based reverse engineering. Mass production of engine blocks — from molten iron to finished precision part."}
        </p>

        {/* Key badges */}
        <div className="flex flex-wrap gap-3">
          {(isRu
            ? ["Собственный литейный завод", "3D Реверс-инжиниринг", "EAC & ISO Сертифицировано", "Серийное производство K4M"]
            : ["In-House Foundry + CNC", "3D Reverse Engineering", "EAC & ISO Certified", "K4M Mass Production"]
          ).map((badge) => (
            <div
              key={badge}
              className="flex items-center gap-2 px-4 py-2 rounded-full"
              style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-check-line text-xs" style={{ color: "#F59E0B" }} />
              <span className="text-xs font-medium text-white whitespace-nowrap">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
